import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { NgSelectModule } from '@ng-select/ng-select';
import { RenunciaPesquisaComponent } from "./pesquisa/renuncia-pesquisa.component";
import { RenunciaListagemComponent } from "./listagem/renuncia-listagem.component";
import { RenunciaRoutingModule } from "./renuncia-routing.module";
import { TarefasComponent } from "./tarefas/tarefas.component";
import { ListagemJanela } from "./tarefas/listagem-janela/listagem-janela.component";
import { RenunciaCadastroComponent } from "./cadastro/renuncia-cadastro.component";
import { ProtocoloRenunciaPesquisaComponent } from "./consulta-protocolo/protocolo-renuncia-pesquisa.component";
import { ProtocoloRenunciaListagemComponent } from "./consulta-protocolo/protocolo-renuncia-listagem.component";

@NgModule({
  declarations: [
    RenunciaPesquisaComponent,
    RenunciaListagemComponent,
    RenunciaCadastroComponent,
    TarefasComponent,
    ListagemJanela,
    RenunciaListagemComponent,
    ProtocoloRenunciaPesquisaComponent,
    ProtocoloRenunciaListagemComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    RenunciaRoutingModule,
    NgSelectModule
  ],
})
export class RenunciaModule { }

